module.exports = __webpack_public_path__ + "static/favicon/apple-touch-icon.png";